import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import './registerServiceWorker'
import router from './router'

import './assets/bootstrap.min.css';
import './assets/bootstrap.bundle.min';

Vue.config.productionTip = false

VTooltip.enabled = window.innerWidth > 768
Vue.use(VTooltip);

Vue.directive('percentage', {
  bind: function () {
    this.handler = function () {
      this.el.value = this.el.value.replace(/\D+/, '')
    }.bind(this)
    this.el.addEventListener('input', this.handler)
  },
  unbind: function () {
    this.el.removeEventListener('input', this.handler)
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
